module.exports = __webpack_public_path__ + "static/media/TrelloSales.d1c4e53d.png";